import request from '../../axios';

const postExtendAdvertisement = async (advertisement_id: string) => {
  await request.post(
    `/api/v2/store/advertisement-extension/${advertisement_id}`,
  );
};

export default postExtendAdvertisement;
